import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  
  withCredentials: true,   //  VERY IMPORTANT
});
// console.log(process.env.REACT_APP_API_URL)

// Only needed for ngrok (remove in production)
API.interceptors.request.use((req) => {
  if (process.env.REACT_APP_API_URL?.includes("ngrok")) {
    req.headers["ngrok-skip-browser-warning"] = "true";
  }
  return req;
});

export default API;